import { ReactNode, useContext, useLayoutEffect } from 'react';
import { LAYOUT_WITHOUT_SIDEBAR } from '@contexts/layout/layout.type';
import { LayoutContext } from '@contexts/layout/layout-context';

export const EagerLayoutWithoutSidebar = ({ children }: { children: ReactNode }) => {
  const { setLayout } = useContext(LayoutContext);
  useLayoutEffect(() => {
    setLayout({ type: LAYOUT_WITHOUT_SIDEBAR });
  }, [setLayout]);
  return <>{children}</>;
};
